// extracted by mini-css-extract-plugin
export default {"placeHolderSelect":"dealershipPicker_placeHolderSelect__Vk5dO"};